/**
  * @ngdoc component
  * @name common.component:itxSelect
  *  
  * @param {Object} collection Array of items to be displayed in the combo box 
  * @param {Object} product Description 
  * @param {String} property Description 
  * @param {String} triggerSelector ID of target HTML Element to be updated with the selected value. For example: `#phone-prefix`
  * @param {Function} onSelect Description 
  * @param {Function} onSelectOpened Description 
  * @param {Function} onSelectClosed Description 
  * @param {Object} disableKeyboard Description 
  * @param {Object} disableCustomScrollbars Description
  *
  * @description
  * Select combo for display multiple values.
  * 
*/
(function () {

    'use strict';

    var KEYUP = 38;
    var KEYDOWN = 40;
    var KEYENTER = 13;

    var ItxSelectCmp = {
        bindings: {
            collection: '<',
            product: '<',
            showproperty: '@',
            property: '@',
            triggerSelector: '@',
            onSelect: '&',
            onSelectOpened: '&',
            onSelectClosed: '&',
            disableKeyboard: '<',
            disableCustomScrollbars: '<'
        },
        controller: ItxSelectCmpCtrl,
        controllerAs: '$ctrl',
        template: [
            '<ul class="dropdown-menu" ng-class="{\'no-custom-scrollbars\': $ctrl.disableCustomScrollbars}" ng-mousemove="$ctrl.onMouseMove($event)">',
                '<li ng-repeat="item in $ctrl.collection | filter:$ctrl.filter track by $index">',
                    '<a href="" ng-mousedown="$ctrl.select(item)"> {{ $ctrl.showproperty ? item[$ctrl.showproperty] : item[$ctrl.property] }} </a>',
                '</li>',
                '<li ng-show="($ctrl.collection | filter:$ctrl.filter).length === 0">',
                    '<em ng-bind="$ctrl.text(\'customMap_empty\')"></em>',
                '</li>',
            '</ul>'
        ].join('')
    };

    ItxSelectCmpCtrl.$inject = ['$scope', '$timeout', '$element'];

    function ItxSelectCmpCtrl($scope, $timeout, $element) {
        var _this = this,
            $ul = $element.find('ul'),
            $target,
            selectedItem = null,

            lastCursorPos = null;

            if (!_this.disableCustomScrollbars) {
                Ps.initialize($ul[0], { // jshint ignore: line
                    suppressScrollX: true
                });
            }

        _this.$onInit = function () {
            _this.filter = '';

            $target = $(_this.triggerSelector);

            $target.on('focus', function () {
                showSelect();
            });
            if (_this.disableKeyboard !== true) {
                $target.on('keyup', function (event) {
                    if ([KEYENTER, KEYUP, KEYDOWN].indexOf(event.keyCode) > -1) {
                        return;
                    }
                    _this.filter = $target.val();
                    if (!_this.disableCustomScrollbars) {
                        Ps.update($ul[0], { // jshint ignore: line
                            suppressScrollX: true
                        });
                    }

                    //Hide if no results
                    if ($ul.children().length === 0) {
                        hideSelect();
                    } else {
                        showSelect();
                    }

                    $scope.$digest();
                });

                $target.on('keydown', function(event) {
                    switch(event.keyCode) {
                        case KEYUP:
                            _this.movePrevious();
                            break;
                        case KEYDOWN:
                            _this.moveNext();
                            break;
                        case KEYENTER:
                            _this.selectCurrent();
                    }
                });
            }

            $target.on('blur', function () {
                  
                    if ($target.val()) {
                        var item = _.find(_this.collection, function (item) {
                            if (_.isString(item[_this.property])) {
                                return item[_this.property].toLowerCase() === $target.val().toLowerCase();
                            } else {
                                if (_.isNumber(item[_this.property])) {
                                    return item[_this.property] === parseInt($target.val());
                                }
                            }
                        });

                        if (!item) {
                            item = _.find(_this.collection, function (item) {
                                return item[_this.property].toLowerCase().indexOf($target.val().toLowerCase()) !== -1;
                            });
                        }

                        if (item) {
                            //TODO VOLVER A ACTIVAR ESTO EN UN FUTURO. Ojo con el summary del checkout al cambiar de país que peta.
                            $target.val(item[_this.property]);
                            _this.filter = '';
                            _this.select(item);
                           
                        }
                    }
                    hideSelect();
                
            });

            //Pair of events for closing on click outside
            $target.on('click', function (event) {
                event.stopPropagation();
            });

            $('html').click(function () {
                hideSelect();
            });

            hideSelect(); 
        };

        _this.$onChanges = function () {
            if (!_this.disableCustomScrollbars) {
                Ps.update($ul[0], { // jshint ignore: line
                    suppressScrollX: true
                });
            }
        };

        _this.select = function (item, $event) {            
            if ($event && $event.which !== 13) {
                return;
            }
            $target.val(item[_this.property]);
            // $timeout(function () {
                selectedItem = item;
                _this.onSelect({ item: item, product: _this.product });
            // }, 50);
            hideSelect();
        };

        _this.moveNext = function() {
            if (!_this.selected) {
                _this.focus($ul.children().first());
            } else {
                _this.focus(_this.selected.next());
            }
        };

        _this.movePrevious = function() {
            if (!_this.selected) {
                _this.focus($ul.children().first());
            } else {
                _this.focus(_this.selected.prev());
            }
        };

        _this.onMouseMove = function(event) {
            if (lastCursorPos && lastCursorPos.x === event.screenX && lastCursorPos.y === event.screenY) {
                return;
            }
            lastCursorPos = {x: event.screenX, y: event.screenY};
            if (_this.selected && _this.selected[0] === event.target) {
                return;
            }
            _this.focus($(event.target).closest('li'), true);
        };

        _this.selectCurrent = function() {
            if (_this.selected) {
                _this.selected.children().trigger('mousedown');
                $target.blur();
            }
        };

        _this.focus = function($element, noScrollTo) {
            if ((_this.selected && _this.selected[0] === $element[0]) || !$element || !$element.length ) {
                return;
            }
            if (_this.selected) {
                _this.selected.removeClass('selected');
            }
            _this.selected = $element;
            _this.selected.addClass('selected');
            if (!noScrollTo) {
                _this.scrollIntoView(_this.selected);
            }
        };

        _this.scrollIntoView = function($element) {
            if ($element.length === 0) {
                return;
            }
            var offsetTop = $element[0].offsetTop;
            var scrollTop = $ul.scrollTop();
            var bottomUl = $ul.outerHeight() + scrollTop;
            var newScrollTop;
            if (scrollTop > offsetTop) {
                newScrollTop = offsetTop;
            } else if (bottomUl <= offsetTop) {
                newScrollTop = scrollTop + (offsetTop - bottomUl) + $element.outerHeight();
            }
            if (newScrollTop !== undefined) {
                $ul.animate({
                    scrollTop: newScrollTop
                }, 100);
            }
        };

        _this.text = inditex.text.bind(inditex);

        //Functions
        function hideSelect() {
            $ul.hide();
            if (_this.selected) {
                _this.selected.removeClass('selected');
                lastCursorPos = null;
                _this.selected = null;
            }
            _this.onSelectClosed();
        }

        function showSelect() {
            $ul.show();
            _this.onSelectOpened();
        }
    }

    angular.module('itxApp.legacy')
        .component('itxSelect', ItxSelectCmp);
})();
